import React from 'react'
import { Box, Text } from 'front-end/src/components'
import { brandColors } from 'shared/basicPalette'
import { fontSizes } from '../../chakraThemeExtension'
import './CardTitle.less'

interface ICardTitleProps {
  title: string | null | undefined
  subtitle?: any
  subtitleDark?: boolean
}

export const CardTitle = ({
  title,
  subtitle,
  subtitleDark = true
}: ICardTitleProps) => {
  return (
    <Box className="Card__header">
      <Text as="h2" className="Card__title" noOfLines={3}>
        {title}
      </Text>
      {subtitle && (
        <Box
          fontSize={fontSizes.ssm}
          color={subtitleDark ? brandColors.grey[500] : brandColors.grey[100]}
        >
          {subtitle}
        </Box>
      )}
    </Box>
  )
}

export default CardTitle
